import React from "react";

function Subtitle(props) {
  return (
    <h1 className="fw-bold fs-2 custom-howitworkssubtitle">{props.subtitle}</h1>
  );
}

export default Subtitle;
